import axios from 'axios';

import { IRequestConfig, MethodsTypes } from 'models/Axios';
import { StoreTotemServiceProps, StoreTotemProps, StoreTotemPostProps } from 'models/StoreTotem';

import Services from './index.service';

export default class StoreTotemService extends Services<StoreTotemServiceProps, StoreTotemProps> {

  storeTotem = async (str: string) => {
    const config: IRequestConfig<StoreTotemProps> = {
      url: `${this.base_url}/store/validation-store-subsidiary`,
      method: MethodsTypes.get,
      headers: {
        "Content-Type": "application/json",
        "key": str
      },
    };

    const request = await axios(config)
      .then((result) => result);

    if (request.status !== 200)
      return false;

    return request.data;
  };

  postStoreTotem = async (data: StoreTotemPostProps[], key: string) => {
    const config: IRequestConfig<StoreTotemProps> = {
      url: `${this.base_url}/store/register-store-answer`,
      method: MethodsTypes.post,
      data,
      headers: {
        "Content-Type": 'application/json',
        "key": key || ""
      }
    };

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return error.response;
      }
    );

    return axios(config)
      .then((result) => result);
  };
}